var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 2.58301C12.1916 2.58301 10.8416 3.31634 9.99996 4.44134C9.15829 3.31634 7.80829 2.58301 6.29996 2.58301C3.74163 2.58301 1.66663 4.66634 1.66663 7.24134C1.66663 8.23301 1.82496 9.14967 2.09996 9.99967C3.41663 14.1663 7.47496 16.658 9.48329 17.3413C9.76663 17.4413 10.2333 17.4413 10.5166 17.3413C12.525 16.658 16.5833 14.1663 17.9 9.99967C18.175 9.14967 18.3333 8.23301 18.3333 7.24134C18.3333 4.66634 16.2583 2.58301 13.7 2.58301Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGray);
export default __webpack_public_path__ + "static/media/heart-gray.eba2698e21c4bf714abded61765bb803.svg";
export { ForwardRef as ReactComponent };